import * as yup from "yup";
import { useTranslation } from "react-i18next";

export const appl452ValidationSchema = () => {
  const { t } = useTranslation();
  return yup.object().shape({
    pastApp: yup
      .object()
      .shape({ m02_id: yup.string(), label: yup.string() })
      .nullable()
      .default(undefined)
      .transform((value, originalValue) => {
        if (
          originalValue &&
          typeof originalValue === "object" &&
          Object.keys(originalValue).length === 0
        ) {
          return undefined;
        }
        return value;
      }),
    d50_id: yup.object().required(t("Το πεδίο είναι υποχρεωτικό")),
    boardDate: yup
      .date()
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία"))
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .max(
        new Date(),
        t(
          "Η ημερομηνία απόφασης οργάνου δεν μπορεί να είναι μεταγενέστερη της ημερομηνίας υποβολής της αίτησης.",
        ),
      )
      .min(
        new Date("01/01/1900"),
        t("Ελέγξτε την ημερομηνία απόφασης οργάνου (έτος 4 ψηφία)."),
      ),
    fudocNotary: yup.string().required(t("Το πεδίο είναι υποχρεωτικό")),
    solutionDate: yup
      .date()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
    statuteDate: yup
      .date()
      .required(t("Το πεδίο είναι υποχρεωτικό"))
      .typeError(t("Το πεδίο πρέπει να είναι ημερομηνία")),
  });
};
